import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LangContextProvider } from './context/langContext/LangContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LangContextProvider>
      <App />
    </LangContextProvider>
  </React.StrictMode>
);
